import { settingsPage as EnUsSettingsPage } from '../en-us/settingsPage';
import { AgResourceLanguage } from '../types';

export const settingsPage: AgResourceLanguage['settingsPage'] = {
  ...EnUsSettingsPage,
  title: 'Compte',
  emailAndPassword: {
    title: 'E-mail & Mot de passe',
    changePasswordButton: 'Modifier le mot de passe',
    emailChangeInfo: {
      informationText: "L'e-mail ne peut être modifié que via",
      linkText: 'Customer Happiness'
    }
  },
  userInfo: {
    editButton: 'Modifier',
    title: 'Nom complet'
  },
  modal: {
    changePassword: {
      cancelButton: 'Annuler',
      confirmPasswordLabel: 'Confirmez le mot de passe',
      header: 'Modifier le mot de passe',
      infoBanner: 'Si vous changez votre mot de passe, vous serez automatiquement déconnecté',
      newPasswordLabel: 'Nouveau mot de passe',
      saveButton: 'Enregistrer',
      title: 'Modifier le mot de passe',
      success: 'Le mot de passe a été modifié',
      reloginError: 'Un problème est survenu, vous serez automatiquement déconnecté'
    },
    editFullName: {
      cancelButton: 'Annuler',
      firstName: 'Prénom',
      header: 'Modifier le nom complet',
      lastName: 'Nom de famille',
      saveButton: 'Enregistrer',
      title: 'Nom complet'
    }
  },
  constants: {
    FULL_NAME_SUCCESS: 'Nom complet modifié avec succès',
    PASSWORD_MATCH_MESSAGE: 'Les mots de passe saisis ne correspondent pas',
    SETTINGS_ERROR: 'Un problème est survenu. Veuillez réessayer',
    nameError: 'Doit contenir au moins 1 caractère',
    latinNameError: 'Doit contenir uniquement des caractères latins',
    spacesNameError: 'Les espaces uniquement ne sont pas autorisés',
    minLength: 'Doit contenir au moins 8 caractères',
    uppercase: '1 majuscule',
    lowercase: '1 minuscule',
    number: '1 chiffre',
    spacesPasswordError: 'Les espaces ne sont pas autorisés',
    passwordCaption: 'Doit contenir au moins 8 caractères'
  }
};
